import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { photos } from '../../data/site';
export function PhotoBreak() {
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-15%', '15%']);
  const textX = useTransform(scrollYProgress, [0, 1], ['10%', '-25%']);
  return <section ref={ref} className="relative h-[80vh] min-h-[520px] overflow-hidden bg-ink" data-id="element-137" data-mp="3vcabjrql0s4n">
      <motion.img src={photos.crowdDay} alt="Le groupe Téléphomme sur scène face à une foule de festival, bras levés" style={{
      y,
      scale: 1.25
    }} className="absolute inset-0 h-full w-full object-cover" data-id="element-138" data-mp="44xq30io1six" />
      <div aria-hidden className="absolute inset-0 bg-ink/40" data-id="element-139" data-mp="29ye7mhj1hb1u" />
      <motion.p aria-hidden style={{
      x: textX
    }} className="absolute bottom-8 left-0 whitespace-nowrap font-display text-[20vw] uppercase leading-none text-outline text-paper md:text-[14vw]" data-id="element-140" data-mp="29wusiu94d61n">
        Un autre monde · Un autre monde
      </motion.p>
      <p className="relative mx-auto max-w-7xl px-5 pt-16 font-display text-4xl uppercase leading-none md:px-8 md:text-6xl" data-id="element-141" data-mp="2x9rcvurqzlel">
        200 fois,
        <br data-id="element-142" data-mp="3b5usoj1vjr7j" />
        le même frisson.
      </p>
    </section>;
}